export default __webpack_public_path__ + "static/media/adaptability.79cae61e.svg";